import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";

const Breadcrumbs = ({ breadcrumbs = [] }) => { 
  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-end">
            <div className="page-title-right">
              <Breadcrumb listClassName="m-0">
              {/* Cette ligne permet à l'utilisation de .map pour générer chaque élément du breadcrumb depuis le tableau 'breadcrumbs' */}
                {breadcrumbs.map((item, index) => (
                  <BreadcrumbItem key={index} active={index === breadcrumbs.length - 1}>
                    {/* Cette ligne permet que si 'item.link' existe, on crée un lien, sinon on affiche le label en texte */}
                    {item.link ? (
                      <Link to={item.link}>{item.label}</Link>
                    ) : (
                      item.label // Cette ligne permet que si il n'y a pas de 'link', on affiche simplement le texte
                    )}
                  </BreadcrumbItem>
                ))}
              </Breadcrumb>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Breadcrumbs;
